import { combineReducers } from "redux";
import { all } from "redux-saga/effects";
import { downloadListSlice } from "../app/components/DownloadDialog/DownloadListSlice";
import * as auth from "../app/modules/Auth/_redux/authRedux";
import { userProfileSlice } from "../app/modules/Auth/_redux/userProfileSlice";
import { callLogsDownloadListSlice } from "../app/modules/CallLogs/DownloadDialog/callLogsDownloadListSlice";
import { slice as callLogsSlice } from "../app/modules/CallLogs/listingsSlice";
import { configurationSlice } from "../app/modules/Configuration/state/slices/configurationSlice";
import {
  dispositionIdSlice,
  dispositionSlice,
  modalName
} from "../app/modules/Configuration/state/slices/dispositionSlice";
import { phonebookSlice } from "../app/modules/Configuration/state/slices/phonebookSlice";
import { stickyAgentSlice } from "../app/modules/Configuration/state/slices/stickyAgentState";
import {
  emailTemplateSlice,
  smsTemplateSlice,
  tabbingTemplateSlice
} from "../app/modules/Configuration/state/slices/templateSlice";
import { reportTabSlice } from "../app/modules/Configuration/_redux/slices/ReportSlice";
import { configurationTabSlice } from "../app/modules/Configuration/_redux/slices/ReportTabSlice";
import * as configuration from "../app/modules/Configuration/_redux/state/configurationRedux";
import { slice as crmSlice } from "../app/modules/CRM/listingsSlice";
import * as dashboard from "../app/modules/Dashboard/_redux/dashboardRedux";
import { agentsActivityListingsSlice } from "../app/modules/Insights/pages/insights/agent-analytics/agent-activity/agents-activity-listings-table/listingsSlice";
import { agentCallInsightsSlice } from "../app/modules/Insights/pages/insights/agent-analytics/agent-call-insights/agent-call-insights-table/listingsSlice";
import { adminAgentFollowupsSlice } from "../app/modules/Insights/pages/insights/agent-analytics/agent-follow-ups/agent-follow-ups-table/agentListingsSlice";
import { agentUnderAdminFollowupSlice } from "../app/modules/Insights/pages/insights/agent-analytics/agent-follow-ups/agent-follow-ups-table/agentUnderAdminListingSlice";
import { agentSettingsFilterSlice } from "../app/modules/Settings/pages/Settings/AgentSettings/AgentFiltersSlice";
import { agentSettingsSlice } from "../app/modules/Settings/state/slices/agentsettingsSlice";
import { hookapiSlice } from "../app/modules/Settings/state/slices/hookapiSlice";

import { agentSettingsCSVLogsListSlice } from "../app/modules/Settings/pages/Settings/AgentSettings/CSVLogs/CSVLogsSlice";
import { manageAgentsDialogTabSlice } from "../app/modules/Settings/state/slices/agentsettingsSlice";

import { agentFollowupsSlice } from "../app/modules/Insights/pages/insights/agent-analytics/agent-follow-ups/agent-follow-ups-table/listingsSlice";
import { agentFollowupsSliceOverdue } from "../app/modules/Insights/pages/insights/agent-analytics/agent-follow-ups/agent-follow-ups-table/listingsSliceOverdue";
import { supervisorCallInsightsSlice } from "../app/modules/Insights/pages/insights/supervisor-analytics/supervisor-call-insights/supervisor-call-insights-table/listingsSlice";
import * as insights from "../app/modules/Insights/_redux/insightsRedux";
import { callMonitoringCallsSlice } from "../app/modules/LiveInteractions/pages/CallMonitoring/LiveCalls/callMonitoringCallsSlice";
import { agentStatusReducer } from "../app/modules/LiveInteractions/state/reducers/agentStatusReducer";
import { callStatusReducer } from "../app/modules/LiveInteractions/state/reducers/callStatusReducers";
import { customerStatusReducer } from "../app/modules/LiveInteractions/state/reducers/customerStatusReducer";
import { queueMonitorReducer } from "../app/modules/LiveInteractions/state/reducers/queueMonitorReducer";
import callMonitoringAgentStatusSaga from "../app/modules/LiveInteractions/state/sagas/agentStatusSaga";
import callStatusSaga from "../app/modules/LiveInteractions/state/sagas/callStatusSaga";
import queueMonitorSaga from "../app/modules/LiveInteractions/state/sagas/queueMonitorSaga";
import { liveInteractionsSlice } from "../app/modules/LiveInteractions/state/slices/liveInteractionsSlice";
import { settingsSlice } from "../app/modules/Settings/state/slices/settingsSlice";
import { campaignSlice } from "../app/modules/Settings/state/slices/campaignSlice";
import { slice as smsLogsSlice } from "../app/modules/SMSLogs/listingsSlice";
import { reducer as tickerReducer } from "../app/modules/Ticker/reducer";
import {soundsSlice} from "../app/modules/Configuration/state/slices/soundsSlice";
import snackbarReducer from "./snackbar";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  dashboard: dashboard.reducer,
  insights: insights.reducer,
  agentsActivityListingsSlice: agentsActivityListingsSlice.reducer,
  agentCallInsightsSlice: agentCallInsightsSlice.reducer,
  agentFollowupsSlice: agentFollowupsSlice.reducer,
  agentFollowupsSliceOverdue: agentFollowupsSliceOverdue.reducer,
  supervisorCallInsightsSlice: supervisorCallInsightsSlice.reducer,
  liveInteractionsSlice: liveInteractionsSlice.reducer,
  callMonitoringCallsSlice: callMonitoringCallsSlice.reducer,
  callStatus: callStatusReducer,
  agentsStatus: agentStatusReducer,
  customerStatus: customerStatusReducer,
  queueMonitor: queueMonitorReducer,
  adminAgentFollowupsSlice: adminAgentFollowupsSlice.reducer,
  agentUnderAdminFollowupSlice: agentUnderAdminFollowupSlice.reducer,
  configurationTabSlice: configurationTabSlice.reducer,
  reportTabSlice: reportTabSlice.reducer,
  configuration: configuration.reducer,
  smsLogsSlice: smsLogsSlice.reducer,
  callLogsSlice: callLogsSlice.reducer,
  crmSlice: crmSlice.reducer,
  ticker: tickerReducer,
  callLogsDownloadListSlice: callLogsDownloadListSlice.reducer,
  downloadListSlice: downloadListSlice.reducer,
  snackbar: snackbarReducer,
  configurationSlice: configurationSlice.reducer,
  settingsSlice: settingsSlice.reducer,
  campaignSlice: campaignSlice.reducer,
  phonebookSlice: phonebookSlice.reducer,
  soundsSlice: soundsSlice.reducer,

  hookapiSlice: hookapiSlice.reducer,
  agentSettingsSlice: agentSettingsSlice.reducer,
  agentSettingsFilterSlice: agentSettingsFilterSlice.reducer,
  agentSettingsCSVLogsListSlice: agentSettingsCSVLogsListSlice.reducer,
  emailTemplateSlice: emailTemplateSlice.reducer,
  smsTemplateSlice: smsTemplateSlice.reducer,
  tabbingTemplateSlice: tabbingTemplateSlice.reducer,
  manageAgentsDialogTabSlice: manageAgentsDialogTabSlice.reducer,
  dispositionSlice: dispositionSlice.reducer,
  dispositionModalName: modalName.reducer,
  dispositionIdSlice: dispositionIdSlice.reducer,
  stickyAgent: stickyAgentSlice.reducer,
  userProfileSlice: userProfileSlice.reducer,
});

export function* rootSaga() {
  yield all([
    auth.saga(),
    dashboard.saga(),
    insights.saga(),
    callStatusSaga(),
    callMonitoringAgentStatusSaga(),
    queueMonitorSaga(),
    configuration.saga(),
  ]);
}
